//#region Function Imports
import React, { useState, useEffect } from 'react'
import { FlatList, StyleSheet, Platform, SafeAreaView, View, useWindowDimensions } from 'react-native'
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../components/CustomButton/CustomButton';
import CustomDropDownWithIcons from '../../../components/CustomDropDownWithIcons';
import { useAuthContext } from "../../../hooks/useAuthContext";
import CustomInput from '../../../components/CustomInput/CustomInput';
import { useAssessment } from '../../../hooks/useAssessment';
import { Card } from 'react-native-paper';
import { useTranslation } from 'react-i18next';
import { showMessage } from "react-native-flash-message";
import { useTheme } from '@react-navigation/native';
import Swal from 'sweetalert2';
//#endregion

const MyAssessmentsAdmin = (props) => {

    //#region Function Consts
    const { t } = useTranslation();
    const { user, clientApi, username } = useAuthContext();
    const { DeleteAssm, DeleteGroup, loadParticipants, loadGroupById, loadGroups } = useAssessment();
    const { width, height } = useWindowDimensions()
    const isHalfScreen = Platform.OS === "web" && width <= 900;
    const { colors } = useTheme()
    const styles = makeStyles(colors, height, width);
    const [loading, setLoading] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState('All Groups');
    const [adminData, setAdminData] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [assmUi, setAssmUi] = useState("");
    const [search, setSearch] = useState("");
    const [group, setGroup] = useState({})
    const [GroupList, setGroupList] = useState([]);
    const [canDelete, setCanDelete] = useState(false);
    const groupsList = [{ label: 'All Groups', value: 'All Groups' }, ...props.groups];
    const [groupChoices, setGroupChoices] = useState(groupsList);
    const assmGroupChoices = [];
    //#endregion

    //#region Filter
    // * Perform Group Filtering, if All Groups update state with parent props.data
    const filterAssessmentsByGroup = () => {
        if (selectedGroup === 'All Groups') {
            setAdminData(props.data);
        } else {
            props.data.forEach(obj => {
                if (obj.assmgroupUi === selectedGroup) {
                    assmGroupChoices.push(obj);
                }
            });
            setAdminData(assmGroupChoices);
        }
    };

    const filterAssessmentsNameSearch = (searchValue) => {
        if (searchValue === '') {
            setAdminData(props.data);
        } else {
            let filteredData = props.data.filter(x => String(x.description.toLowerCase()).includes(searchValue.toLowerCase()));
            setAdminData(filteredData);
        }
    };

    const loadAllGroups = () => {
        loadGroups(clientApi, user.token, username)
            .then((respGroups) => {
                setGroupList(respGroups);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    //#endregion

    //#region Load
    const loadParticipations = (assmUi) => {
        loadParticipants(assmUi)
            .then((respEmployee) => {
                setParticipants(respEmployee);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    //#endregion

    //#region UseEffect
    useEffect(() => {
        if (assmUi !== '') {
            if (participants.length === 0) {
                Swal.fire({
                    title: t('common:areusure'),
                    text: t('common:deleteAssmConfirmation'),
                    icon: "question",
                    showCancelButton: true,
                    reverseButtons: true,
                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                    cancelButtonColor: '#d3d3d3',
                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Delete</text>`,
                    confirmButtonColor: '#A0A2FF',
                }).then((result) => {
                    if (result.isConfirmed) {
                        DeleteAssm(clientApi, user.token, username, assmUi)
                            .then((resp) => {
                                showMessage({
                                    message: "Assessment Deleted Successfully",
                                    type: "error",
                                    duration: 3000,
                                });
                            })
                            .catch((error) => {
                                console.error(error);
                            });
                    }
                });
            } else {
                showMessage({
                    message: "Can't delete Assessment with participants.",
                    type: "error",
                    duration: 3000,
                });
            }
        }
    }, [participants]);

    const deleteAssm = (assmUi) => {
        setAssmUi(assmUi)
        loadParticipations(assmUi)
    };

    useEffect(() => {
        filterAssessmentsNameSearch(search)
    }, [search])

    useEffect(
        () => { },
        [width, height]
    );

    useEffect(() => {
        if (canDelete)
            if (group.locked === false) {
                if (assmGroupChoices.length === 0) {
                    Swal.fire({
                        title: t('common:areusure'),
                        text: t('common:deleteGroupConfirmation'),
                        icon: "question",
                        showCancelButton: true,
                        reverseButtons: true,
                        cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                        cancelButtonColor: '#d3d3d3',
                        confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Delete</text>`,
                        confirmButtonColor: '#A0A2FF',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            DeleteGroup(clientApi, user.token, username, selectedGroup)
                                .then(resp => {
                                    console.log(resp)
                                }).catch(error => {
                                    console.log(error)
                                });
                        }
                    });
                } else {
                    showMessage({
                        message: "Can't Delete Group that contains assessments",
                        type: "error",
                        duration: 3000,
                    });
                }
            } else {
                showMessage({
                    message: "Can't Delete Locked Group",
                    type: "error",
                    duration: 3000,
                });
            }
    }, [group, canDelete]);

    // * UseEffect for Group Dropdown statte change (e.g. from All Groups -> Group X)
    useEffect(() => {
        loadAllGroups();
        filterAssessmentsByGroup();
    }, [selectedGroup])

    useEffect(() => {
        let uniqueDescriptions = new Set();
        const tempChoices = [];
        GroupList.forEach((obj) => {
            if (!uniqueDescriptions.has(obj.description)) {
                tempChoices.push({ label: obj.description, value: obj.assmgroupUI });
                uniqueDescriptions.add(obj.description);
            }
        });
        setGroupChoices([{ label: 'All Groups', value: 'All Groups' }, ...tempChoices]);
    }, [GroupList])

    // * Set Assessment Data to adminData (MyAssessmentsAdmin state) to assist with filtering 
    // * Props.data should always keep the full set of assessment data at all times.
    useEffect(() => {
        setAdminData(props.data)
    }, [])

    //#endregion

    //#region Listeners
    const deleteGroup = () => {
        loadGroupById(clientApi, user.token, username, selectedGroup)
            .then(respGroup => {
                setCanDelete(true)
                setGroup(respGroup)
            }).catch(error => {
                console.log(error)
            });
    }
    //#endregion

    //#region Render Functions
    const AssessmentAdminListView = (item) => {
        return (
            <SafeAreaView style={styles.item}>
                <SafeAreaView style={styles.row}>
                    <CustomLabel
                        value={item.description}
                        type='AVAILABLEUSED' />
                    <View style={styles.verticalLine} />
                    <CustomLabel
                        value={item.assmType}
                        type='AVAILABLEUSED_SECONDARY' />
                    <View style={styles.verticalLine} />
                    <View
                        style={styles.button}>
                        {item.locked === false ?
                            <CustomButton
                                iconName='pencil-outline'
                                onPress={() => {
                                    props.setAssmUi(item.assmUi)
                                    props.setShowMyAssessments(0)
                                    props.setShowResponseScreen(0)
                                    props.setShowResultsScreen(0)
                                    props.setShowMyAssessments(0)
                                    props.setShowAssessmentsAdmin(0)
                                    props.setShowCreateScreen(0)
                                    props.setShowCreateGroup(0)
                                    props.setShowEditScreen(1)
                                }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={20} />
                            :
                            <CustomButton
                                iconName='lock-closed-outline'
                                onPress={() => { }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={20} />
                        }
                        {item.locked === false ?
                            <CustomButton
                                iconName='trash-outline'
                                onPress={() => { deleteAssm(item.assmUi) }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={20} />
                            :
                            <CustomButton
                                iconName='lock-closed-outline'
                                onPress={() => { }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={20} />
                        }
                        <CustomButton
                            iconName='bar-chart'
                            onPress={() => {
                                props.setWfl(item.assmType)
                                props.setAssmUi(item.assmUi)
                                props.setShowMyAssessments(0)
                                props.setShowResponseScreen(0)
                                props.setShowResultsScreen(1)
                                props.setShowMyAssessments(0)
                                props.setShowAssessmentsAdmin(0)
                                props.setShowCreateScreen(0)
                                props.setShowCreateGroup(0)
                                props.setShowEditScreen(0)
                            }}
                            show='HOME_BELL'
                            type='HOME_BELL'
                            textTop='2'
                            sz={20} />
                        <CustomButton
                            text={t('common:addPart')}
                            onPress={() => {
                                props.setWfl(item.assmType)
                                props.setAssmUi(item.assmUi)
                                props.setShowMyAssessments(0)
                                props.setShowResponseScreen(0)
                                props.setShowResultsScreen(0)
                                props.setShowParticipationsScreen(1)
                                props.setShowMyAssessments(0)
                                props.setShowAssessmentsAdmin(0)
                                props.setShowCreateScreen(0)
                                props.setShowCreateGroup(0)
                                props.setShowEditScreen(0)
                            }}
                            iconName="person-add-outline"
                            show="HOME_BELL"
                            type="HOME_BELL"
                            textTop="2"
                            sz={20}
                        />
                    </View>
                </SafeAreaView>
            </SafeAreaView>
        )
    }

    const renderAssessments = ({ item }) => {
        return (
            <Card
                style={styles.cardstyle} >
                <Card.Content>
                    <AssessmentAdminListView {...item} />
                </Card.Content>
            </Card>
        )
    };
    //#endregion

    return (
        <SafeAreaView

            style={styles.mainView}>
            <View style={styles.listWrapper}>
                <FlatList
                    data={adminData}
                    renderItem={renderAssessments}
                    onRefresh={() => props.loadEveryAssessment()}
                    scrollEnabled={true}
                    contentContainerStyle={{ flexGrow: 1 }}
                    refreshing={loading}
                    ListHeaderComponentStyle={{ zIndex: 100000 }}
                    ListHeaderComponent={
                        <SafeAreaView>
                            {/* Search Group component  */}
                            <View style={[styles.row, { zIndex: 1 }]}>
                                <View style={[styles.inputContainer]}>
                                    <CustomDropDownWithIcons
                                        defValue={selectedGroup}
                                        options={groupChoices}
                                        value={selectedGroup}
                                        setValue={setSelectedGroup}
                                        type='MYPROFILE'
                                    />
                                </View>
                                <CustomButton
                                    onPress={() => {
                                        props.setShowCreateGroup(1)
                                        props.setShowMyAssessments(0)
                                        props.setShowResponseScreen(0)
                                        props.setShowResultsScreen(0)
                                        props.setShowMyAssessments(0)
                                        props.setShowAssessmentsAdmin(0)
                                        props.setShowCreateScreen(0)
                                        props.setShowEditScreen(0)
                                    }}
                                    iconName='add-outline'
                                    show='PART'
                                    type='PART'
                                    textTop='0'
                                    text={t('common:groupcreate')}
                                    isGradient={true}
                                    sz={20}
                                />
                                {selectedGroup === 'All Groups' ?
                                    <></> :
                                    <CustomButton
                                        iconName='pencil-outline'
                                        onPress={() => {
                                            props.setShowMyAssessments(0)
                                            props.setShowResponseScreen(0)
                                            props.setShowResultsScreen(0)
                                            props.setShowMyAssessments(0)
                                            props.setShowAssessmentsAdmin(0)
                                            props.setShowCreateScreen(0)
                                            props.setShowCreateGroup(0)
                                            props.setShowEditScreen(0)
                                            props.setResponseGroupId(selectedGroup)
                                            props.setShowEditGroup(1)
                                        }}
                                        show='PART'
                                        type='PART'
                                        textTop='2'
                                        isGradient={true}
                                        sz={20} />
                                }
                                {selectedGroup !== 'All Groups' && assmGroupChoices.length === 0 &&
                                    <CustomButton
                                        iconName='trash-outline'
                                        onPress={() => { deleteGroup() }}
                                        show='PART'
                                        type='PART'
                                        textTop='2'
                                        sz={20} />
                                }
                                <View style={styles.halfverticalLine} />
                                <CustomInput
                                    placeholder="Type to search assesments..."
                                    value={search}
                                    setValue={setSearch}
                                    type="SEARCH"
                                />
                                <CustomButton
                                    onPress={() => {
                                        props.setShowCreateGroup(0)
                                        props.setShowMyAssessments(0)
                                        props.setShowResponseScreen(0)
                                        props.setShowResultsScreen(0)
                                        props.setShowMyAssessments(0)
                                        props.setShowAssessmentsAdmin(0)
                                        props.setShowCreateScreen(1)
                                        props.setShowEditScreen(0)
                                    }}
                                    text={t('common:newAssm')}
                                    iconName='add-outline'
                                    show='PART'
                                    type='PART'
                                    textTop='0'
                                    sz={20}
                                    isGradient={true}
                                />
                            </View>
                            <SafeAreaView>
                                {/* flalist column names */}
                                <View style={styles.rowHeader}>
                                    <CustomLabel
                                        value={t('common:assessmentname')}
                                        type='SUBTITLE' />
                                    <View style={styles.verticalLine} />
                                    <CustomLabel
                                        value={t('common:assessmenttype')}
                                        type='SUBTITLE' />
                                    <View style={styles.verticalLine} />

                                    <CustomLabel
                                        value={t('common:assmfunctionality')}
                                        type='SUBTITLE' />
                                </View>
                            </SafeAreaView>
                        </SafeAreaView>
                    }
                />
            </View >

        </SafeAreaView >
    )
}

const makeStyles = (colors, height, width, isHalfScreen) => StyleSheet.create({
    mainView: {
        flex: 1,
        height: (Platform.OS === 'web' ? height * 60 / 100 : '95%'),
        justifyContent: 'center',
    },
    listWrapper: {
        flex: 1,
        padding: 10,
        marginBottom: 10,
    },
    cardstyle: {
        backgroundColor: colors.background_white,
        borderWidth: 1,
        borderColor: colors.border_card,
        borderRadius: 14,
        shadowColor: 'rgba(92, 143, 26, 1)',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.08,
        shadowRadius: 12,
        elevation: 3,
        overflow: 'hidden',
        marginVertical: 16,
    },
    verticalLine: {
        backgroundColor: colors.buttons_primary,
        height: '100%',
        width: 1,
    },
    halfverticalLine: {
        backgroundColor: colors.buttons_primary,
        height: '75%',
        marginHorizontal: 30,
        width: 0,
    },
    rowHeader: {
        marginTop: 10,
        flexDirection: "row",
        marginHorizontal: '2%',
    },
    row: {
        flex: 1,
        flexDirection: "row"
    },
    button: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: "center",
        alignItems: "center",
    },
    buttonAdd: {
        flex: 1,
        flexDirection: 'row',
        alignSelf: "center",
        alignItems: "center",
    },
    inputContainer: {
        margin: 20,
        flex: 1,
        width: isHalfScreen ? '30%' : '100%',
        justifyContent: 'flex-end',
    },
})

export default MyAssessmentsAdmin
